import { render } from "./userPrivacy.vue?vue&type=template&id=23596763&scoped=true"
import script from "./userPrivacy.vue?vue&type=script&lang=js"
export * from "./userPrivacy.vue?vue&type=script&lang=js"

import "./userPrivacy.vue?vue&type=style&index=0&id=23596763&scoped=true&lang=css"

import exportComponent from "/Users/h5/Desktop/project/外包/xiaocanghui/chn-link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23596763"]])

export default __exports__